
export enum GermanyResponsibleGamingButtonPlacement {
    inGame = 0,
    inDetailedHistory = 1
}